module.exports = "<div #map id=\"map\">\n    <div id=\"popup\" class=\"ol-popup\">\n        <app-map-popup [data]=\"popupData\" (closePopup)=\"onClosePopup()\">\n        </app-map-popup>\n    </div>\n    <div id=\"search-popup\" class=\"ol-search-popup\" *ngIf=\"isSearching\">\n        <app-map-search-popup [addresses]=\"filteredAddresses\" (closePopup)=\"onCloseSearchPopup()\" (filterAddresses)=\"onSubmitSearchData($event)\" (zoomToFeature)=\"onZoomToFeature($event)\"></app-map-search-popup>\n    </div>\n</div>\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./libs/map/components/map.component.html
// module id = ./libs/map/components/map.component.html
// module chunks = main